
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lighting-retrofit",
      function () {
        return require("private-next-pages/lighting-retrofit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lighting-retrofit"])
      });
    }
  